import { AdjustmentsFilterHorizontalIcon } from '@zola/zola-ui/src/components/SvgIconsV3/AdjustmentsFilterHorizontal';
import { excludeDesktopV2 } from '@zola/zola-ui/src/styles/emotion/mixins/responsiveV2';

import { AllFacetParentKey } from '~/types/types';

import { FilterButton, MobileFilterButtonWrapper } from './MobileFilterButton.styles';

type MobileFilterButtonProps = {
  setDrawerOpenTo: (value: null | true | AllFacetParentKey) => void;
};

export const MobileFilterButton = ({ setDrawerOpenTo }: MobileFilterButtonProps) => {
  return (
    <MobileFilterButtonWrapper css={excludeDesktopV2}>
      <FilterButton onClick={() => setDrawerOpenTo(true)} size="large">
        <AdjustmentsFilterHorizontalIcon height={24} width={24} title="" />
        Filter
      </FilterButton>
    </MobileFilterButtonWrapper>
  );
};
